import { useTheme } from "next-themes";
import React, { useEffect, useMemo, useRef } from "react";

import { useAppSelector } from "@/services/hooks/redux.hooks";

let tvScriptLoadingPromise: any;

export default function TradingViewWidget({
  height,
  asset,
  style = "1",
}: {
  height: number;
  asset: string;
  style?: string;
}) {
  const { selectedExchange } = useAppSelector(
    (state) => state.exchangeSwitcher,
  );
  const { language } = useAppSelector((state) => state.user);

  const { theme } = useTheme();
  const onLoadScriptRef: any = useRef();

  const graphId = useMemo(() => {
    return `asset-${asset}`;
  }, [asset]);

  useEffect(() => {
    onLoadScriptRef.current = createWidget;

    if (!tvScriptLoadingPromise) {
      tvScriptLoadingPromise = new Promise((resolve) => {
        const script = document.createElement("script");
        script.async = true;
        script.id = "tradingview-widget-loading-script";
        script.src = "https://s3.tradingview.com/tv.js";
        script.type = "text/javascript";
        script.onload = resolve;

        document.head.appendChild(script);
      });
    }

    tvScriptLoadingPromise.then(
      () => onLoadScriptRef.current && onLoadScriptRef.current(),
    );

    function createWidget() {
      if (document.getElementById(graphId) && "TradingView" in window) {
        new (window.TradingView as any).widget({
          width: "100%",
          height: height,
          symbol: `${asset}`,
          interval: "D",
          timezone: "Etc/UTC",
          theme: theme,
          style: style,
          locale: language,
          hide_legend: true,
          allow_symbol_change: false,
          save_image: false,
          calendar: false,
          hide_volume: true,
          container_id: graphId,
        });
      }
    }

    return () => {
      onLoadScriptRef.current = null;
      return;
    };
  }, [
    asset,
    graphId,
    height,
    style,
    language,
    selectedExchange?.provider_name,
    theme,
  ]);

  return (
    <div className="flex-[2.5] inset-0">
      <div id={graphId} className="border-0 rounded-sm" />
    </div>
  );
}
